/**
 * Copied from frame-ui
 * {@link https://github.com/tractableai/frame-ui/blob/main/src/theme/colour.ts}
 */

export enum Color {
  Primary = "#4C30FB",
  DarkBlue = "#113148",
  White = "#FFFFFF",
  LightBlue = "#94B8D2",
  BorderBlack = "#12191F26",

  // Text (WIP)
  TextPrimary = "#2E3338", // Grey90
  TextSecondary = "#555E66", // Grey70
  TextTertiary = "#68727A", // Grey50
  TextLink = "#3B25C4", // Purple60
  TextDestructive = "#BF332E", // Red50
  TextReversed = "#FFFFFF", // White

  // Icon (WIP)
  IconAction = "#3B25C4", // Purple60
  IconPrimary = "#2E3338", // Grey90
  IconSecondary = "#68727A", // Grey50
  IconDestructive = "#BF332E", // Red40
  IconReversed = "#FFFFFF",

  // Other
  PageBackgroundPrimary = "#FFFFFF",
  PageBackgroundSecondary = "#F5F6F7", // Grey30
  SeparatorMinimal = "#E9ECF0",
  SepratorBold = "#A0A9B0",

  // Red
  Red5 = "#F9EEEE",
  Red10 = "#F8E1DE",
  Red30 = "#F2938C",
  Red40 = "#E9695F",
  Red50 = "#BF332E",
  Red60 = "#A23737",

  // Orange
  Orange5 = "#FEF2E4",
  Orange10 = "#FCE2C5",
  Orange30 = "#F09860",
  Orange40 = "#E66F0E",
  Orange60 = "#8C471C",

  // Yellow
  Yellow5 = "#FFF5C2",
  Yellow10 = "#FEE685",
  Yellow20 = "#FACE00",
  Yellow30 = "#DDAA01",
  Yellow60 = "#776017",

  // Green
  Green5 = "#DBF6ED",
  Green10 = "#C7EFE2",
  Green40 = "#34A37E",
  Green50 = "#2E8367",
  Green60 = "#286846",

  // Cyan
  Cyan5 = "#E7F6F8",
  Cyan10 = "#CCF2F1",
  Cyan30 = "#5DD1CF",
  Cyan40 = "#44ACAC",
  Cyan60 = "#2A6D6C",

  // Blue
  Blue5 = "#E8F5FF",
  Blue10 = "#D4E5FF",
  Blue30 = "#81AEFC",
  Blue40 = "#5994f6",
  Blue60 = "#0050D8",

  // Purple
  Purple5 = "#F4F2FF",
  Purple10 = "#E2DEFF",
  Purple30 = "#B5A8FF",
  Purple60 = "#3B25C4",
  Purple80 = "#2A2163",

  // Grey
  Grey3 = "#F5F6F7",
  Grey5 = "#E9ECF0",
  Grey10 = "#DADFE3",
  Grey20 = "#C2C9CF",
  Grey30 = "#A0A9B0",
  Grey40 = "#D6D6D6",
  Grey50 = "#68727A",
  Grey70 = "#3D4852",
  Grey80 = "#1F272E",
  Grey90 = "#2E3338",
}

const brandColors = {
  red: {
    5: Color.Red5,
    10: Color.Red10,
    30: Color.Red30,
    40: Color.Red40,
    50: Color.Red50,
    60: Color.Red60,
  },
  orange: {
    5: Color.Orange5,
    10: Color.Orange10,
    30: Color.Orange30,
    40: Color.Orange40,
    60: Color.Orange60,
  },
  yellow: {
    5: Color.Yellow5,
    10: Color.Yellow10,
    20: Color.Yellow20,
    30: Color.Yellow30,
    60: Color.Yellow60,
  },
  green: {
    5: Color.Green5,
    10: Color.Green10,
    40: Color.Green40,
    50: Color.Green50,
    60: Color.Green60,
  },
  cyan: {
    5: Color.Cyan5,
    10: Color.Cyan10,
    30: Color.Cyan30,
    40: Color.Cyan40,
    60: Color.Cyan60,
  },
  blue: {
    5: Color.Blue5,
    10: Color.Blue10,
    30: Color.Blue30,
    40: Color.Blue40,
    60: Color.Blue60,
  },
  grey: {
    3: Color.Grey3,
    5: Color.Grey5,
    10: Color.Grey10,
    20: Color.Grey20,
    30: Color.Grey30,
    40: Color.Grey40,
    50: Color.Grey50,
    70: Color.Grey70,
    80: Color.Grey80,
    90: Color.Grey90,
  },
};

const solidColors = {
  white: Color.White,
  darkBlue: Color.DarkBlue,
  lightBlue: Color.LightBlue,
  borderBlack: Color.BorderBlack,
};

const themedColors = {
  primary: Color.Primary,

  textPrimary: Color.TextPrimary,
  textSecondary: Color.TextSecondary,
  textTertiary: Color.TextTertiary,
  textLink: Color.TextLink,
  textDestructive: Color.TextDestructive,
  textReversed: Color.TextReversed,

  iconAction: Color.IconAction,
  iconPrimary: Color.IconPrimary,
  iconSecondary: Color.IconSecondary,
  iconDestructive: Color.IconDestructive,
  iconReversed: Color.IconReversed,

  pageBackgroundPrimary: Color.PageBackgroundPrimary,
  pageBackgroundSecondary: Color.PageBackgroundSecondary,
  separatorMinimal: Color.SeparatorMinimal,
  sepratorBold: Color.SepratorBold,
};

export const colors = {
  ...brandColors,
  ...solidColors,
  ...themedColors,
};
